import { render, staticRenderFns } from "./DateMeal-orderFood.vue?vue&type=template&id=20cd61e4&scoped=true&"
import script from "./DateMeal-orderFood.vue?vue&type=script&lang=js&"
export * from "./DateMeal-orderFood.vue?vue&type=script&lang=js&"
import style0 from "./DateMeal-orderFood.vue?vue&type=style&index=0&id=20cd61e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd61e4",
  null
  
)

export default component.exports